export default __webpack_public_path__ + "static/light_bulb_w.3e3dcd29f5b5b8ba90be03b467fc2ac8.svg";